var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _vm.text
        ? _c("div", { key: "label", staticClass: "separator-custom" }, [
            _c("span", { staticClass: "text active" }, [
              _vm._v(_vm._s(_vm.text))
            ])
          ])
        : _c(
            "div",
            { key: "filter-options", staticClass: "separator-custom" },
            _vm._l(_vm.options, function(option, idx) {
              return _c(
                "span",
                {
                  key: option.name,
                  class: `text fixed ${option.class} ${
                    option.active ? "active" : ""
                  }`,
                  attrs: { "data-id": `${option.id ? option.id : idx}` },
                  on: { click: _vm.changeOption }
                },
                [_vm._v(" " + _vm._s(option.name) + " ")]
              )
            }),
            0
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }